<form class="form" [formGroup]="contactForm" (ngSubmit)="save()">
  <form-group title="{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.PERSON' | translate }}" isLast="true">
    <field-holder>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.FIRST_NAME' | translate }}</mat-label>
        <input matInput maxlength="250" formControlName="firstName" required autocomplete="off" />
        <mat-error *ngIf="contactForm.get('firstName').hasError('required')">
          {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.FIRST_NAME_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    <field-holder>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.LAST_NAME' | translate }}</mat-label>
        <input matInput maxlength="250" formControlName="lastName" required autocomplete="off" />
        <mat-error *ngIf="contactForm.get('lastName').hasError('required')">
          {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.LAST_NAME_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    <field-holder>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.PHONE' | translate }}</mat-label>
        <input matInput formControlName="phone" required autocomplete="off" />
        <mat-error *ngIf="contactForm.get('phone').hasError('required')">
          {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.PHONE_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
    <field-holder>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.EMAIL' | translate }}</mat-label>
        <input matInput maxlength="250" formControlName="email" required autocomplete="off" />
        <mat-error *ngIf="contactForm.get('email').hasError('required')">
          {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.EMAIL_ERROR' | translate }}
        </mat-error>
        <mat-error *ngIf="contactForm.get('email').hasError('email')">
          {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.EMAIL_INVALID' | translate }}
        </mat-error>
      </mat-form-field>
    </field-holder>
  </form-group>

  <form-footer>
    <button mat-stroked-button color="primary" type="button" (click)="closeDialog()"
      class="form-footer__button form-footer__button--secondary">
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" type="submit" class="form-footer__button form-footer__button--primary"
      [disabled]="contactForm.invalid">
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </form-footer>
</form>